export const GET_USER_PERMISSIONS = 'GET_USER_PERMISSIONS'



// WEBPACK FOOTER //
// ./src/actionTypes/Permissions/Permissions.js